import {ButtonSubmit, hexToRgbA, T} from "./connector";
import styled from "styled-components";
import moment from "moment";
import {MinusOutlined} from '@ant-design/icons';
import {TUICallType} from "tuicall-engine-webrtc";

interface ChatHeaderProps {
    name?: string;
    title?: string;
    onEndChatClick?: () => void;
    onMinus?: () => void;
    onCall?: (type: "VIDEO" | "AUDIO") => void;
    endChatAt?: string,
    rightText?: string;
    calling?: boolean;
    view?: 'chat' | 'history' | 'call';
    setView?: (view: 'chat' | 'history' | 'call') => void;
    onGoingCall?: () => void;
    callType?: any
}

export const ChatHeader = (props: ChatHeaderProps) => {
    return (
        <Header>
            <ChatTabs mainTitle={props?.title} title={props?.name} value={props.view} onChange={props.setView}/>
            <div style={{display: 'flex', justifyContent: "flex-end", alignItems: 'center', gap: 8}}>
                {
                    props?.rightText ? (
                        <EndChatAt>{props?.rightText}</EndChatAt>
                    ) : (
                        <>
                            {
                                !props?.endChatAt ? (
                                        <>
                                            {props?.onCall && (
                                                <Calls>
                                                    {
                                                        props?.calling ? (
                                                            <>
                                                                <OngoingCallButton onClick={() => {
                                                                    props?.setView("call");
                                                                    props?.onGoingCall?.();
                                                                }}>
                                                                    {props?.callType === TUICallType.VIDEO_CALL ? (
                                                                        <IconVideoCall/>) : (<IconAudioCall/>)}
                                                                    {T("Ongoing Call")}
                                                                </OngoingCallButton>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <CallButton onClick={() => props?.onCall("AUDIO")}>
                                                                    <IconAudioCall/>
                                                                </CallButton>
                                                                <CallButton onClick={() => props?.onCall("VIDEO")}>
                                                                    <IconVideoCall/>
                                                                </CallButton>
                                                            </>
                                                        )
                                                    }
                                                </Calls>
                                            )}

                                            {props?.onMinus && (<>
                                                {
                                                    props?.calling ? (
                                                        <OngoingCallButton onClick={() => {
                                                            props?.setView("call");
                                                            props?.onGoingCall?.();
                                                        }}>
                                                            {props?.callType === TUICallType.VIDEO_CALL ? (
                                                                <IconVideoCall/>) : (<IconAudioCall/>)}
                                                            {T("Ongoing Call")}
                                                        </OngoingCallButton>
                                                    ) : (
                                                        <HeaderClose className={'minus'}
                                                                     onClick={props?.onMinus}><MinusOutlined/></HeaderClose>
                                                    )
                                                }
                                            </>)}
                                            {props?.onEndChatClick &&
                                                <HeaderClose disabled={props?.calling}
                                                             onClick={props?.onEndChatClick}>{T("End Chat")}</HeaderClose>}
                                        </>
                                    ) :
                                    <EndChatAt>{T("Chat ended at")} {moment(props?.endChatAt).format("DD/MM/YYYY HH:mm")}</EndChatAt>
                            }
                        </>
                    )
                }
            </div>
        </Header>
    )
}


const ChatTabs = (props) => {
    return (
        <Tabs>
            {
                props?.title ? (
                    <>
                        <Tab style={{padding: 0}} onClick={() => props?.onChange?.('chat')}
                             className={props.value === 'chat' ? 'active' : ""}>
                            {
                                props?.mainTitle ? props?.mainTitle : (
                                    <>
                                        {T("Live chat")}
                                    </>
                                )
                            }
                        </Tab>
                    </>
                ) : (
                    <>
                        <Tab onClick={() => props?.onChange?.('chat')}
                             className={props.value === 'chat' ? 'active' : ""}>{T("Chat")}</Tab>
                        <Tab onClick={() => props?.onChange?.('history')}
                             className={props.value === 'history' ? 'active' : ""}>{T("History")}</Tab>
                    </>
                )
            }
        </Tabs>
    )
}

const Tabs = styled.div`
    margin: 0;
    color: #4E4E4E;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;
const Tab = styled.div`
    color: #494949;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    padding: 0 20px;
    border-bottom: 2px solid transparent;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex: 1;

    &.active {
        color: ${props => props.theme.main || "#40A68C"};
        border-bottom-color: ${props => props.theme.main || "#40A68C"};
    }
`;

const Header = styled.div`
    display: flex;
    height: 60px;
    padding: 0px 16px;
    justify-content: space-between;
    align-items: center;
    background: #FFF;
    flex: none;
`;

const HeaderClose = styled(ButtonSubmit)`
    height: 32px;
    width: 100px;
    font-size: 16px;
    line-height: 24px;
    margin: 0 !important;
    background-color: #F04646 !important;

    &.minus {
        padding: 0 !important;
        width: auto;
        background-color: transparent !important;

        svg {
            color: #636363;
        }
    }
`;

const OngoingCallButton = styled(ButtonSubmit)`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.main} !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    height: 32px;
    border-radius: 90px;
    border: 1.5px solid ${props => props.theme.main} !important;
    background: ${props => hexToRgbA(props.theme.main, 0.1)} !important;
    padding: 0 12px;
    width: auto;
    margin: 0;

    svg {
        width: 20px;
        margin-right: 6px;

        * {
            fill: ${(props) => props.theme.main} !important;
            stroke: ${(props) => props.theme.main} !important;
        }
    }
`;

const EndChatAt = styled.div`
    color: #8E8E8E;
    font-size: 14px;
    font-weight: 300;
    text-align: end;
`;

const Calls = styled.div`
    gap: 16px;
    display: flex;
    border-right: 1px solid #E5E5E5;
    padding-right: 16px;
    margin-right: 12px;
    height: 30px;
    justify-content: center;
    align-items: center;
`;
const CallButton = styled(ButtonSubmit)`
    border: none !important;
    padding: 0 !important;
    width: auto;
    background-color: transparent !important;
    margin: 0;
    height: auto !important;

    svg {
        fill: ${props => props.theme.main} !important;
    }
`;

export const IconVideoCall = (props) => (
    <svg {...props} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <g>
                <path
                    d="M24.675 7.19829C24.1967 6.94163 23.1934 6.67329 21.8284 7.62996C21.0917 8.1511 20.0691 7.63467 19.8127 6.76953C19.1877 4.66008 17.5725 3.79163 14.5834 3.79163H7.58335C3.59335 3.79163 2.04169 5.34329 2.04169 9.33329V18.6666C2.04169 21.35 3.50002 24.2083 7.58335 24.2083H14.5834C17.5725 24.2083 19.1877 23.3398 19.8127 21.2304C20.0691 20.3652 21.0917 19.8488 21.8284 20.37C22.5517 20.8833 23.1817 21.0466 23.6834 21.0466C24.115 21.0466 24.4534 20.9183 24.675 20.8016C25.1534 20.5566 25.9584 19.8916 25.9584 18.2233V9.77663C25.9584 8.10829 25.1534 7.44329 24.675 7.19829ZM12.8334 13.2766C11.6317 13.2766 10.64 12.2966 10.64 11.0833C10.64 9.86996 11.6317 8.88996 12.8334 8.88996C14.035 8.88996 15.0267 9.86996 15.0267 11.0833C15.0267 12.2966 14.035 13.2766 12.8334 13.2766Z"
                    fill="#1D896D"/>
            </g>
        </g>

    </svg>
);

export const IconAudioCall = (props) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.9313 17.3187L10.85 19.4C10.4112 19.8387 9.71375 19.8387 9.26375 19.4112C9.14 19.2875 9.01625 19.175 8.8925 19.0513C7.73375 17.8812 6.6875 16.655 5.75375 15.3725C4.83125 14.09 4.08875 12.8075 3.54875 11.5363C3.02 10.2538 2.75 9.0275 2.75 7.8575C2.75 7.0925 2.885 6.36125 3.155 5.68625C3.425 5 3.8525 4.37 4.44875 3.8075C5.16875 3.09875 5.95625 2.75 6.78875 2.75C7.10375 2.75 7.41875 2.8175 7.7 2.9525C7.9925 3.0875 8.25125 3.29 8.45375 3.5825L11.0638 7.26125C11.2663 7.5425 11.4125 7.80125 11.5138 8.04875C11.615 8.285 11.6713 8.52125 11.6713 8.735C11.6713 9.005 11.5925 9.275 11.435 9.53375C11.2888 9.7925 11.075 10.0625 10.805 10.3325L9.95 11.2212C9.82625 11.345 9.77 11.4913 9.77 11.6713C9.77 11.7613 9.78125 11.84 9.80375 11.93C9.86037 12.081 9.93103 12.2271 10.016 12.3642C10.2252 12.7019 10.5332 13.1143 10.94 13.595C11.4462 14.18 11.9862 14.7762 12.5712 15.3725C12.6837 15.485 12.8075 15.5975 12.92 15.71C13.37 16.1488 13.3813 16.8687 12.9313 17.3187Z"
            fill="#1D896D"/>
        <path
            d="M25.2164 21.1202C25.2164 21.4352 25.1601 21.7614 25.0476 22.0764C25.0139 22.1664 24.9801 22.2564 24.9351 22.3464C24.7439 22.7514 24.4964 23.1339 24.1701 23.4939C23.6233 24.0965 23.0212 24.5331 22.3418 24.8146C22.3308 24.8191 22.3188 24.8218 22.3082 24.8271C22.2976 24.8324 22.2857 24.835 22.2748 24.8394C21.6156 25.1051 20.9012 25.2489 20.1314 25.2489C18.9839 25.2489 17.7576 24.9789 16.4639 24.4277C15.1701 23.8764 13.8764 23.1339 12.5939 22.2002C11.8882 21.6755 11.8352 20.6638 12.4571 20.042L14.2765 18.2226C14.6795 17.8196 15.3065 17.7957 15.8114 18.0602C15.8676 18.0827 15.9351 18.1164 16.0139 18.1502C16.1039 18.1839 16.1939 18.1952 16.2951 18.1952C16.4864 18.1952 16.6326 18.1277 16.7564 18.0039L17.6114 17.1602C17.8926 16.8789 18.1626 16.6652 18.4214 16.5302C18.6801 16.3727 18.9389 16.2939 19.2201 16.2939C19.4339 16.2939 19.6589 16.3389 19.9064 16.4402C20.1539 16.5414 20.4126 16.6877 20.6939 16.8789L24.4176 19.5227C24.7101 19.7252 24.9126 19.9614 25.0364 20.2427C25.1489 20.5239 25.2164 20.8052 25.2164 21.1202Z"
            fill="#1D896D"/>
    </svg>
)
